import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/checkmark.tsx
import { jsx } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "M21 8L9 18L3 13.0002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }
);
var Checkmark = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  Checkmark
};
